import { useState, useMemo, useCallback, useContext, useEffect, useRef } from 'react';
import TaskItemCounter from './pane-left-task-counter';
import ListRecipients from './pane-left-recipients';

import { SelectBox } from 'devextreme-react/select-box';
import { AccountContext } from '../context/account-context';
import { getMemberships, getAccounts } from '../common/api-requests';
import './pane-left.scss';
import { TasksCounterProvider } from '../context/tasks-counter-context';
import { ErrorContext } from '../context/error-context';
import { RecipientContext } from '../context/recipient-context';
import { RecipientsContext } from '../context/recipients-context';

export default function PaneLeft() {
    // const listRecipients = useMemo(() => <ListRecipients handleRecipientChanged={handleRecipientChanged} />, []);

    const [account, setAccount] = useContext(AccountContext);
    const [memberships, setMemberships] = useState([]);
    const [clientID, setClientID] = useState(null);
    const [error, setError] = useContext(ErrorContext);
    const dxSelectBoxClients = useRef(null);
    const [recipients, setRecipients] = useContext(RecipientsContext);

    useEffect(() => {

        if (!account)
            return;

        getMemberships().then((data) => {
            if (!data)
                return;

            setMemberships([{ id: 0, projectName: "Всі", clientName: "Всі" }, ...data]);
        })
            .catch((errorInner) => {
                setError("(" + errorInner.status + ")" + " " + errorInner.text);
            });

    }, [account])

    const displayExpr = (item) => {
        if (!item)
            return "";

        if (!item.id)
            return "Всі";

        return "Проект: " + item.projectName + " Клієнт: " + item.clientName;
    };

    const handleOnSelectionChanged = useCallback((e) => {

        if (!e.selectedItem)
            return;

        getAccounts(e.selectedItem.clientID).then((accounts) => {

            if (accounts && accounts.length) {
                accounts = accounts.sort(function (a, b) {
                    const dateA = a.lastMessage ? new Date(a.lastMessage.ondate) : new Date(0);
                    const dateB = b.lastMessage ? new Date(b.lastMessage.ondate) : new Date(0);
                    return dateB - dateA;
                });

                setRecipients(accounts);
            }
        })
            .catch((errorInner) => {
                setError("(" + errorInner.status + ")" + " " + errorInner.text);
            });
    });

    useEffect(() => {
        dxSelectBoxClients.current.instance.option("value", memberships.length ? memberships[0].id : null);
    }, [memberships])


    if (!account)
        return <></>

    return (
        <div className="recipients">
            <TasksCounterProvider>
                <TaskItemCounter></TaskItemCounter>
            </TasksCounterProvider>

            <div className='dxSelectBoxClients'>

                <SelectBox
                    ref={dxSelectBoxClients}
                    width="100%"
                    items={memberships}
                    valueExpr="id"
                    displayExpr={displayExpr}
                    onSelectionChanged={handleOnSelectionChanged}
                >

                </SelectBox>

            </div>
            <ListRecipients recipients={recipients} />

        </div>
    );
}

